import React from 'react'

import { PasswordCondition } from '../PasswordCondition'
import { strings } from './strings'

interface PasswordConditionsProps {
  validationStatus: {
    minLength: boolean | null
    upperAndLowerCase: boolean | null
    numberAndLetter: boolean | null
  }
}

export const PasswordConditions: React.FC<PasswordConditionsProps> = ({
  validationStatus,
}) => {
  return (
    <>
      <PasswordCondition
        label={strings.firstRequirement}
        isValid={validationStatus.minLength}
      />
      <PasswordCondition
        label={strings.secondRequirement}
        isValid={validationStatus.upperAndLowerCase}
      />
      <PasswordCondition
        label={strings.thirdRequirement}
        isValid={validationStatus.numberAndLetter}
      />
    </>
  )
}
